import { css } from '@emotion/react';
import { t } from 'i18n';

import { theme } from '../../theme';
import { LegacyCartItem } from '../LegacyCartItem';

const styles = {
  container: css`
    font-size: ${theme.fontSize.sm};
  `,
};

type Props = {
  className?: string;
  travelers: {
    label: string;
    count: number;
  }[];
};

export function TravelersCartItem({ travelers, className }: Props) {
  return (
    <LegacyCartItem className={className} title={t('common:travelers')} css={styles.container}>
      {travelers.map(({ label, count }) => (
        <div key={label}>
          {count} {label}
        </div>
      ))}
    </LegacyCartItem>
  );
}
